import { default as AllProductsNav } from '@ux/mobile-nav';
import ProductNav from './product-nav';

//
// Export the Class and related children.
//
export {
  ProductNav as default,
  AllProductsNav
};
